import PropTypes from 'prop-types';
import Certification from '@/domain/Certification';
import Container from '@/components/Container';
import Link from '@/components/Link';
import client from '@/api/client';
import { certificationListingQuery } from '@/api/queries';

export async function getStaticProps() {
  const { data } = await client().query({ query: certificationListingQuery });

  return {
    props: {
      certifications: data?.certifications?.nodes || [],
    }
  }
}

const defaultProps = {
  certifications: [],
};

const propTypes = {
  certifications: PropTypes.arrayOf(PropTypes.object),
};

export default function Certifications({
  certifications,
}) {
  return (
    <div>
      <div className="bg-white shadow-sm relative z-10">
        <Container>
          <div className="flex items-center relative -mb-px space-x-4 lg:space-x-6">
            <Link className="font-medium py-4 px-1 flex items-center border-b-2 border-transparent text-gray-500 hover:text-gray-900" href="/entrenamientos">
              Entrenamientos
            </Link>
            <span className="font-medium py-4 px-1 flex items-center border-b-2 text-green-500 border-green-500">
              Certificaciones
            </span>
          </div>
        </Container>
      </div>
      <div className="bg-white bg-gradient-to-b from-gray-100 to-gray-100 relative">
        <div className="py-10 lg:py-12 relative z-10">
          <Container>
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10 xl:gap-12">
              {certifications.map(({ id, ...certification }) => (
                <div key={id} className="lg:col-span-6 xl:col-span-4 flex w-full">
                  <Certification {...certification} />
                </div>
              ))}
            </div>
          </Container>
        </div>
      </div>
    </div>
  );
}

Certifications.defaultProps = defaultProps;
Certifications.propTypes = propTypes;
